module.exports = __webpack_public_path__ + "img/sCrazyMnky_193x205.3ac05e7a.png";